import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Spinner from './Spinner';

function NftImage({ nft, spinnerDimensionClasses }) {
  let imageId = null;
  if (nft?.params?.url) {
    imageId = nft?.params?.url.split('ipfs://')[1];
  }

  const imageUrl = `https://ipfs.io/ipfs/${imageId}`;

  return (
    <div className='relative flex items-center justify-center w-full bg-gray-800 aspect-square'>
      <LazyLoadImage
        height={400}
        width={400}
        src={imageUrl}
        alt={nft?.params?.name}
        effect='blur'
        wrapperClassName='absolute inset-0 !w-full !h-full z-10'
      />
      <Spinner dimensionClasses={spinnerDimensionClasses} />
    </div>
  );
}

export default NftImage;
